// extracted by mini-css-extract-plugin
module.exports = {"button":"BaseButton_button__eYDD6","pseudo":"BaseButton_pseudo__nSOAi"};